import { MTableEditField } from '@material-table/core';
import React from 'react';
import { DISTRIBUIDOR, FABRICANTE, IMPORTADOR, UJ } from 'utils/constants/reach_role';
import { shortDate as dateFormater } from 'utils/helperFunctions/dateFormat';

const emptyCellFiller = field => field ? field : '-';


export default (user, userAccount, rawMaterial, suppliers, shipmentType) => {

  let papelReach = {};
  let supplier = {};

  switch (shipmentType) {
    case IMPORTADOR:
      papelReach.initialEditValue = IMPORTADOR;
      papelReach.editable = 'never';
      break;
    case DISTRIBUIDOR:
      papelReach.initialEditValue = DISTRIBUIDOR;
      papelReach.editable = 'never';
      break;
    case UJ:
      papelReach.initialEditValue = UJ;
      papelReach.editable = 'never';
      break;
    case FABRICANTE:
      papelReach.initialEditValue = FABRICANTE;
      papelReach.editable = 'never';
      supplier.editable = 'never';
      supplier.initialEditValue = userAccount.supplier_id;
  }

  let columns = [
    {
      title: 'Código Fornecimento',
      field: 'code',
      minWidth: 100,
      render: ({ code }) => emptyCellFiller(code)
    },
    {
      title: 'Desig. Comercial',
      field: 'trade_name',
      minWidth: 100,
      render: ({ trade_name }) => emptyCellFiller(trade_name)
    },

    {
      title: 'Fornecedor',
      field: 'supplier_id',
      lookup: suppliers,
      initialEditValue: Object.keys(suppliers)[0],
      minWidth: 200,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props}/>,
      ...supplier
    },
    {
      title: 'Papel Reach',
      field: 'reach_role',
      width: 100,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
      },
      initialEditValue: UJ,
      lookup: {
        //'-': '-',
        [UJ]: 'UJ',
        [FABRICANTE]: 'Fabricante',
        [IMPORTADOR]: 'Importador',
        [DISTRIBUIDOR]: 'Distribuidor'
      },
      ...papelReach
    },
    {
      title: 'Data FDS',
      field: 'sds_date',
      width: 100,
      type: 'date',
      initialEditValue: null,
      render: ({ sds_date }) => sds_date && emptyCellFiller(dateFormater(sds_date))
    },
    {
      title: 'CE',
      field: 'exposure_scenario',
      width: 70,
      initialEditValue: 'sim',
      lookup: {
        '-': '-',
        'sim': 'Sim',
        'nao': 'Não',
        'na': 'N/A'
      }
    },
    {
      title: 'Nº Registo (xx-xxxxxxxxxx-xx-xxxx)',
      field: 'registration_number',
      //initialEditValue: 'xx-xxxxxxxxxx-xx-xxxx',
      minWidth: 300,
      render: ({ registration_number }) => emptyCellFiller(registration_number)
    },
    {
      title: 'Observações',
      field: 'observations',
      render: ({ observations }) => emptyCellFiller(observations)
    }
  ];

  /**
   * When Adding a SHIPMENT for a SUBSTANCE that is still not a RAW MATERIAL
   * (meaning doesn't still have a code) code of SUBSTANCE should be updated
   */
  if (!rawMaterial.code || rawMaterial.code === '') {
    columns = [
      {
        title: 'Código MP',
        field: 'code',
        render: ({ code }) => emptyCellFiller(code)
      },
      ...columns
    ];
  }

  return columns;
};
